module.exports = __webpack_public_path__ + "img/quiz.71c62cb1.svg";